import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import FavoriteIcon from '@mui/icons-material/Favorite'
import { Divider, Fab, Paper } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useState, useCallback, useMemo } from 'react'

import { useRefreshSignal } from '../contexts/refreshSignal'
import { useBusinessLogic } from '../hooks/useBusinessLogic'

import { UpdateForm } from './forms/UpdateSasaviForm'

const ItemContainer = styled(Paper)(({ theme }) => ({
  elevation: 9,
  marginLeft: '1rem',
  marginRight: '1rem',
  marginBottom: '1rem',
  padding: '1rem',
  borderRadius: '1rem',
  border: `1px solid ${theme.palette.divider}`,
  boxShadow:
    theme.palette.mode === 'dark'
      ? '0 0 80px 0 rgba(0, 0, 0, 0.5)'
      : '0 0 100px 0 rgba(0, 0, 0, 0.1)'
}))

const ItemButtons = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row-reverse',
  direction: 'row',
  margin: '0.5rem',
  '& > *:not(:last-child)': {
    marginLeft: '.7rem' // Add margin between the Fabs except for the last one
  }
}))

const UnderLayer = styled('div')(() => ({
  marginTop: '1rem',
  marginBottom: '1rem'
  // marginTop: '1rem',
  // paddingTop: '3rem',
  // marginBottom: '10px',
  // zIndex: 0
}))

const MyContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  // marginBottom: '10px',
  zIndex: 0
}))

const parseComment = (comment) => {
  comment = comment.replace(
    /https?:\/\/[^\s]+/g,
    '<a href="$&" target="_blank" rel="noopener noreferrer">$&</a>'
  )
  return comment.replace(/\n/g, '<br />')
}

const Item = ({ item }) => {
  const [isDeleted, setIsDeleted] = useState(false)
  const [itemToUpdate, setItemToUpdate] = useState(null)

  if (isDeleted) return null

  return (
    <ItemContainer>
      {!itemToUpdate && (
        <ViewItem
          item={item}
          setItemToUpdate={setItemToUpdate}
          setIsDeleted={setIsDeleted}
        />
      )}
      {itemToUpdate && (
        <EditItem
          itemToUpdate={itemToUpdate}
          setItemToUpdate={setItemToUpdate}
        />
      )}
    </ItemContainer>
  )
}

const EditItem = ({ itemToUpdate, setItemToUpdate }) => {
  return (
    <UpdateForm itemToUpdate={itemToUpdate} setItemToUpdate={setItemToUpdate} />
  )
}

const Content = styled('p')(({ theme }) => ({
  // whiteSpace: 'pre-wrap'
  a: {
    color: theme.palette.primary.main
  }
}))

const ViewItem = ({ item, setItemToUpdate, setIsDeleted }) => {
  const [isLikeProcessing, setIsLikeProcessing] = useState(false)
  const { likeItem, deleteItem } = useBusinessLogic()
  const { triggerRefresh } = useRefreshSignal()

  console.log('item in ViewItem', item)
  const { comment, createdAt, _attachments } = item

  const myAttachments = _attachments ? Object.entries(_attachments) : []
  console.log('myAttachments in ViewItem', myAttachments)
  const myAttachment = myAttachments[0] ?? null
  console.log('myAttachment in ViewItem', myAttachment)
  // if(_attachments) {

  //   console.log('item in item.js', Object.values(_attachments))
  //   const attachments = Object.values(_attachments)
  //   const attachment = attachments[0]
  //   console.log('attachment in item.js', atob(attachment.data))
  //   if (attachment.content_type === 'text/csv') {
  //     myStuff = atob(attachment.data)
  //   }
  // }

  const parsedComment = parseComment(comment)
  const date = useMemo(
    () =>
      new Intl.DateTimeFormat(navigator.language, {
        dateStyle: 'short',
        timeStyle: 'short'
      }).format(new Date(createdAt)),
    [createdAt]
  )

  const handleLikeClick = useCallback(async () => {
    if (isLikeProcessing) return // Prevent multiple rapid clicks

    setIsLikeProcessing(true)
    try {
      await likeItem(item)
      triggerRefresh()
      // Note: The parent will refresh the list via refresh signal
    } finally {
      // Add a small delay to prevent rapid successive clicks
      setTimeout(() => setIsLikeProcessing(false), 300)
    }
  }, [isLikeProcessing, likeItem, item])

  const handleDeleteClick = useCallback(async () => {
    try {
      await deleteItem(item)
      // Hide this component immediately
      setIsDeleted(true)
    } catch (error) {
      // Optionally show error message to user
    }
  }, [item, deleteItem])

  const handleUpdateClick = async () => {
    // uses the useItemToUpdate hook
    setItemToUpdate(item)
  }

  return (
    <>
      <Content
        dangerouslySetInnerHTML={{
          __html: parsedComment
        }}
      />
      {myAttachments.length > 0 && <MediaItems attachments={myAttachments} />}
      <Divider />
      <MyContainer>
        <UnderLayer>
          <div>{date}</div>
        </UnderLayer>
        <ItemButtons>
          {/* // They'll be displayed in reverse order */}

          {/* <Fab color="primary" aria-label="delete"> */}
          <Fab color="primary" aria-label="delete" onClick={handleDeleteClick}>
            <DeleteIcon />
          </Fab>

          <Fab color="secondary" aria-label="edit" onClick={handleUpdateClick}>
            <EditIcon />
          </Fab>
          <Fab
            color={item.liked ? 'primary' : 'default'} // Change color if liked
            aria-label="like"
            onClick={handleLikeClick}
            disabled={isLikeProcessing}
          >
            <FavoriteIcon />
          </Fab>
        </ItemButtons>
      </MyContainer>
    </>
  )
}

const MediaItems = ({ attachments }) => {
  console.log('attachments in MediaItems', attachments.length)
  return (
    <>
      {attachments.map((attachment, index) => (
        <Media key={index} attachmentData={attachment} />
      ))}
    </>
  )
}

const Media = ({ attachmentData }) => {
  if (!attachmentData) return null
  const [filename, attachment] = attachmentData

  if (attachment.content_type === 'text/csv') {
    return (
      <ItemContainer
        dangerouslySetInnerHTML={{
          __html: atob(attachment.data)
        }}
      />
    )
  }
  if (attachment.content_type === 'image/png' || attachment.content_type === 'image/jpeg' || attachment.content_type === 'image/jpg') {
    return (
      <ItemContainer>
        <figure>
          <img
            loading="lazy"
            src={`data:${attachment.content_type};base64,${attachment.data}`}
            width="100%"
            alt={filename}
          />
          <figcaption>{filename}</figcaption>
        </figure>
      </ItemContainer>
    )
  }

  return null
}

const NoItems = styled('div')(() => ({
  marginTop: '1rem',
  marginBottom: '1rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
}))

const NoItemsText = styled('div')(() => ({
  marginTop: '1rem'
  // marginBottom: '1rem'
}))

const NoItem = ({ isFilterByLiked }) => {
  const mainTexts = {
    topText: 'You haven\'t sasavi\'d anything yet!',
    bottomText: 'Use the \'+\' button to add something!'
  }

  const likedFilterTexts = {
    topText: 'You haven\'t liked anything yet!',
    bottomText: 'Use the \'Like\' button to like something!'
  }

  const texts = isFilterByLiked ? likedFilterTexts : mainTexts
  return (
    <NoItems>
      <NoItemsText>{texts.topText}</NoItemsText>
      <NoItemsText>{texts.bottomText}</NoItemsText>
    </NoItems>
  )
}

export { Item, NoItem }
